// extracted by mini-css-extract-plugin
export default {"processHeadline":"DesignProcess_processHeadline__JwOfO","processParagraph":"DesignProcess_processParagraph__CHLl0","processUL":"DesignProcess_processUL__wYN9V"};